<template>
  <div class="w-full h-full">
    <div class="flex items-center mt-5px justify-between">
      <TableButtonGroup :list="['点巡检', '机器人巡检']" v-model="tabName" @btn-click="tabClick" />
      <el-date-picker
        class="!w-9/20"
        v-model="keyWords"
        type="date"
        placeholder="选择日期"
        popper-class="visualization-picker-popper"
        value-format="yyyy-MM-dd HH:mm:ss"
        @change="dateChange"
      >
      </el-date-picker>
    </div>
    <el-table
      ref="tableRef"
      height="calc(100% - 90px)"
      class="mt-10px"
      :data="tableData"
      highlight-current-row
      row-key="id"
    >
      <el-table-column width="50" :label="`${$t('序号')}`" type="index"></el-table-column>
      <el-table-column
        :label="`${$t('巡检轮次')}`"
        show-overflow-tooltip
        prop="content"
        v-if="tabName === '点巡检'"
      >
      </el-table-column>
      <el-table-column :label="`${$t('巡检任务')}`" show-overflow-tooltip prop="taskName" v-else>
      </el-table-column>
      <el-table-column :label="`${$t('巡检时间')}`" show-overflow-tooltip prop="createTime">
      </el-table-column>
      <el-table-column :label="`${$t('操作')}`" show-overflow-tooltip width="50">
        <template #default="{ row }">
          <div class="w-15px cursor-pointer text-[#00BCC8]" @click="lookDetail(row)">查看</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :total="page.total"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      class="h-35px mt-5px text-center"
      layout="prev, pager, next"
      @current-change="dateChange()"
      :pager-count="5"
    >
    </el-pagination>
  </div>
</template>

<script>
import { ViewRecordApi, PatrolApi, ViewPointApi } from '@wiz-api/huizhou2'
import TableButtonGroup from '@/components/cockpit/TableButtonGroup'
import dayjs from 'dayjs'
import { transferSkipCount } from '@/assets/js/TransferPage'

const patrolApi = new PatrolApi()
const viewPointApi = new ViewPointApi()
const viewRecordApi = new ViewRecordApi()

export default {
  props: {
    transferProps: {
      type: Object,
      default: () => {
        return {}
      },
    },
    cloudRender: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  components: { TableButtonGroup },
  data() {
    return {
      keyWords: '',
      tableData: [],
      page: {
        total: 0,
        pageSize: 15,
        pageNo: 1,
      },
      tabName: '点巡检',
    }
  },
  methods: {
    tabClick(value) {
      if (value === '机器人巡检') {
        this.getrobotTableData()
      } else {
        this.getPointTableData()
      }
    },
    async lookDetail(row) {
      if (this.tabName === '机器人巡检') {
        const [err, res] = await viewPointApi.getViewPointSync({ robotId: row.robotGuid })
        if (!err) {
          if (res && res.position) {
            this.drawMarker(res, 'robot-normal')
            this.moveToTag(res.perspective)
          }
        }
      } else if (row.position) {
        this.drawMarker(row, 'point-inspection-normal')
        this.moveToTag(row.perspective)
      }
    },
    // 绘制图标
    async drawMarker(deviceDetail, type) {
      await this.cloudRender.Marker?.destroyAllMarker()
      const backgroundUrl = `data://../apps/markers/inspectionAPicture/${type}.png`
      const pictureOption = {
        id: deviceDetail.id,
        pos: JSON.parse(deviceDetail.position),
        backgroundUrl,
        visible: true,
        nodeOffset: [0, 0],
        imgSize: [41, 59],
        markPosType: 1,
      }
      await this.cloudRender.Marker.createByPicture(pictureOption)
    },
    // 移动至标签
    async moveToTag(strPosition) {
      if (!strPosition) return
      const perspective = JSON.parse(strPosition)
      const cameraParams = {
        eye: perspective[0].split(',').map((it) => {
          return Number(it)
        }),
        target: perspective[1].split(',').map((it) => {
          return Number(it)
        }),
        up: perspective[2].split(',').map((it) => {
          return Number(it)
        }),
      }
      await this.cloudRender.Camera.moveCamera('CameraParam', cameraParams)
    },
    dateChange() {
      if (this.tabName === '机器人巡检') {
        this.getrobotTableData()
      } else {
        this.getPointTableData()
      }
    },
    // 获取机器人巡检数据
    async getrobotTableData() {
      const [err, res] = await viewRecordApi.getList({
        createStartTime: this.keyWords,
        skipCount: transferSkipCount(this.page.pageNo, this.page.pageSize),
        maxResultCount: this.page.pageSize,
      })
      if (!err) {
        this.tableData = res.items.map((it) => {
          it.createTime = dayjs(it.createTime).format('YYYY-MM-DD HH:mm:ss')
          return it
        })
        this.page.total = res.totalCount
      }
    },
    // 获取点巡检数据
    async getPointTableData() {
      const [err, res] = await patrolApi.getPatrolRecords({
        time: this.keyWords,
        skipCount: transferSkipCount(this.page.pageNo, this.page.pageSize),
        maxResultCount: this.page.pageSize,
      })
      if (!err) {
        this.tableData = res.items.map((it, index) => {
          it.createTime = dayjs(it.startTime).format('YYYY-MM-DD HH:mm:ss')
          it.id = index
          return it
        })
        this.page.total = res.totalCount
      }
    },
    recordingPropsEvent(event) {
      if (event?.detail?.paramsTime) {
        this.keyWords = event.detail.paramsTime
        this.tabClick(this.tabName)
      }
    },
  },
  created() {
    window.addEventListener('recordingProps', this.recordingPropsEvent)
  },
  mounted() {},
  async beforeDestroy() {
    await this.cloudRender?.Marker?.destroyAllMarker()
    window.removeEventListener('recordingProps', this.recordingPropsEvent)
  },
}
</script>

<style>
</style>
